import AssetsUnderAdviceGrid from "../../features/assetsunderadvicegrid";
import { AssetViewTypes } from "../../features/assetsunderadvicegrid/hooks/AssetsUnderAdviceContext";

const FundsSummaryPage = () => (
    <section className="px-4 my-3 h-100">
        <AssetsUnderAdviceGrid viewType={AssetViewTypes.FundsSummary} />
    </section>
);

export default FundsSummaryPage;